import {
  CircleButtonArrowLeft,
  CircleButtonArrowRight,
  CircleButtonClose,
  StyledCircleButton,
} from './CircleButton.styles';
import * as React from 'react';

type directions = 'right' | 'left' | 'close';

export interface CircleButtonProps {
  /**
   * What type of arrow or symbol is in the button?
   */
  direction: directions;
  /**
   * Is there something to be completed before the user can complete the action?
   */
  disabled?: boolean;
  /**
   * Optional click handler
   */
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
}

/**
 * Button for moving between screens, specifically between questions in Open Reporting desktop view.
 */
export const CircleButton: React.FC<CircleButtonProps> = ({
  disabled = false,
  direction = 'right',
  ...props
}: CircleButtonProps) => {
  return (
    <StyledCircleButton disabled={disabled} direction={direction} {...props}>
      {direction === 'right' && <CircleButtonArrowRight />}
      {direction === 'left' && <CircleButtonArrowLeft />}
      {direction === 'close' && (
        <CircleButtonClose src="/assets/close-icon-white.png" />
      )}
    </StyledCircleButton>
  );
};

export default CircleButton;
